import { Icon } from "semantic-ui-react";

import { StatusIcon } from "components";
import "components/AppointmentStatusCell/AppointmentStatusCell.scss";

import type { DraggableAttributes } from "@dnd-kit/core";
import type { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";
import type { AppointmentStatus, COMMUNICATION_STATUSES, STATUS_IDENTIFIERS } from "models";

type AppointmentStatusValue = {
  id: STATUS_IDENTIFIERS;
  car_in_shop?: string | null;
  car_check_paused_at?: string | null;
  car_out_of_shop?: string | null;
  customcom_status?: COMMUNICATION_STATUSES | null;
};

type StatusCellProps = {
  value: AppointmentStatusValue;
  shadow?: boolean;
  showSubIcon?: boolean;
  showMoveCursor?: boolean;
  statuses?: AppointmentStatus[];
  dndAttributes?: DraggableAttributes;
  dndListeners?: SyntheticListenerMap;
};

const defaultStatus: AppointmentStatus = {
  id: 0,
  identifier: 1,
  ordering: 0,
  dealer_location_id: 0,
  created_on: "",
  updated_on: "",
  icon: "settings",
  color: "",
  name: ""
};

export const getAppointmentStatus = (appointmentStatus?: STATUS_IDENTIFIERS, locationStatuses?: AppointmentStatus[]) => {
  if (!locationStatuses) return defaultStatus;

  return locationStatuses.find(s => s.identifier === appointmentStatus) || defaultStatus;
};

export const AppointmentStatusCell = ({
  value,
  shadow = true,
  dndAttributes = { role: "", tabIndex: 0, "aria-disabled": false, "aria-pressed": undefined, "aria-roledescription": "", "aria-describedby": "" },
  dndListeners = {},
  showMoveCursor,
  statuses
}: StatusCellProps) => {
  const status = getAppointmentStatus(value.id, statuses);

  return (
    <div
      className="StatusCellIcon"
      style={{ backgroundColor: status.color, boxShadow: shadow ? "-1px 1px 3px #00000029" : "none", ...(showMoveCursor && { cursor: "move" }) }}
      title={status.name}
      {...dndAttributes}
      {...dndListeners}
    >
      {value.car_out_of_shop && <Icon className="right from bracket small-icon" />}
      <StatusIcon status={status.identifier} appointment={value} />
    </div>
  );
};
